<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        class="woom-bike-outline woom-up"
        viewBox="0 0 800 600"
        style="enable-background: new 0 0 800 600"
        xml:space="preserve"
        v-once>
        <g class="bike">
            <g>
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M375.6,413.2l142.2-216.5l5.2,11.2l19.9-8.9l-27-59.4l-19.3,8.9l1.9,4.3c0,0-94.4,63.4-105.6,70.6
					c-11.2,7.2-28.7,20-40.5,22.5s-45,3.4-45,3.4l-2.8-6.7l-13.8,5.9l14.7,34.9c0,0-131.1,88.4-140.3,95.5c-9,6.9-8.3,9.9-8.3,9.9
					c0,9.3,31.2,10.3,39.7,10.8c8.5,0.3,129.9,8.2,132.7,8.9c0,0,4.2,1.7,7,3.8c2.6,1.9,21.7,16.3,23.5,17.7c2.3,1.7,3.3,0.3,5.3-2.7" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M356.3,364.6l-41.1-96.8c0,0,39.9-4.7,51.5-10.3c11.7-5.6,103.1-64.2,103.1-64.2L356.3,364.6z" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M503.1,219c0,0-15.6-12-25.8,3.7s-96.7,146.4-98.6,149.4s-4.3,11.1,10.5,20.3" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M523.7,208.7l-0.2,3c0,0,3.2,5.3,3.8,5.9c0.5,0.5,1.7,2.5,5.6,0.5c1.9,3.4,8,14.5,8,14.5l15.5-6.9l-3.3-10.5
					l-3.7-5.5l-4.2-8.2l-2.1-1.6" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M542.6,233.1c0.1,0.3,17.4,39.3,17.4,39.3" />
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="555.3"
                    y1="227.1"
                    x2="572.8"
                    y2="266.8" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M572.8,257.2c-1.5-7.1-3.6-16.1-4.5-18.2c-1.6-3.6-5.1-9.2-5.1-9.2s8.2-0.9,10.2,1.8
					c2.2,2.7,5.3,26.4,5.3,26.4s1.9,12.6,4.7,22.4c2.8,9.6,16.1,41.7,16.1,41.7l15.8,38.9l24.5,20.4c0,0,6.3,4.5,2,10.9
					c-3.2,4.8-8.5,3.9-13.1,0.7c-5.4-3.7-4.6-3.4-4.6-3.4l-10.9,4.5l-56.6-120c0,0,17.5-7.1,17.8-7.8C574.6,266,573.8,262,572.8,257.2
" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M174.1,381.1c-2.6,1.7-1.6,5.7,1.6,5.9h0.1c4.1,0.1,163.3,3.6,163.3,3.6l3.2-4.9c0,0-10.9-40.1-14.2-48.4
					c-3.3-8.3-18.6-44.8-18.6-44.8L174.1,381.1z" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M387.8,446.9l-36.1-32.4c0,0-6.1-6.9,0-13.4s13.7,0.5,13.7,0.5l40.4,45.3" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M405.1,456.6c-3,2.8-5.4,1.3-7.3-0.3" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M406.3,447.5" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M339.5,378.5l-20.3-18.7c0,0-4.3-3.7-8,0.2c-3.8,3.9-2,6.9-0.5,8.6s19.8,21.7,19.8,21.7" />
                <g>
                    <path
                        class="fill-none stroke-woom-black stroke-2"
                        d="M579,254.7c17.1-7.1,36-11.1,55.7-11.1c80,0,144.9,64.9,144.9,144.9s-64.8,144.8-144.9,144.8
						s-144.9-64.8-144.9-144.9c0-51.4,26.8-96.5,67.1-122.2" />
                    <path
                        class="fill-none stroke-woom-black stroke-2"
                        d="M569.4,258.9c1.5-0.7,2-0.9,3.4-1.7" />
                    <path
                        class="fill-none stroke-woom-black stroke-2"
                        d="M583.7,279.2c15.5-7.2,32.8-11.3,51.1-11.3c66.6,0,120.6,53.9,120.6,120.6s-53.9,120.6-120.6,120.6
						s-120.6-53.9-120.6-120.6c0-40.1,19.7-75.7,49.9-97.6" />
                </g>
                <g>
                    <path
                        class="fill-none stroke-woom-black stroke-2"
                        d="M309.3,407.6c-8.6,71.8-69.8,125.7-143.9,125.7c-80.1,0-144.9-64.8-144.9-144.9s64.9-144.9,144.9-144.9
						c46.6,0,88.1,22.1,114.7,56.3" />
                    <path
                        class="fill-none stroke-woom-black stroke-2"
                        d="M286.3,308.6c15.6,23.1,23.9,49.9,23.9,79.8c0,0.5,0,1,0,1.5" />
                    <path
                        class="fill-none stroke-woom-black stroke-2"
                        d="M284.9,405.3C277.3,464.6,226.7,509,165.3,509c-66.6,0-120.6-53.9-120.6-120.6s53.9-120.6,120.6-120.6
						c38.4,0,72.5,17.9,94.6,45.8" />
                    <path
                        class="fill-none stroke-woom-black stroke-2"
                        d="M265.7,321.6c12.8,19.1,20.2,42.1,20.2,66.8" />
                </g>
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="319.2"
                    y1="359.8"
                    x2="334.8"
                    y2="359.8" />
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="328.6"
                    y1="367.7"
                    x2="337.1"
                    y2="367.7" />
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="311.1"
                    y1="360"
                    x2="307.4"
                    y2="360" />
                <polygon
                    class="fill-none stroke-woom-black stroke-2"
                    points="380.9,447.1 421,447.1 421,456.3 381,456.3" />
                <circle
                    class="fill-none stroke-woom-black stroke-2"
                    cx="358.5"
                    cy="407.6"
                    r="5.4" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M436.4,283.3l-5.1-2.4c-2.3-1-4.9-0.9-7,1.3c-1,1.1-1.6,2.5-1.6,4c-1.7,0.1-3.1,0.9-4,1.9
					c-2.1,2.2-2.5,4.8-1,7c-2.6-0.7-5.5,0-7.5,2.1c-1.9,2-2.5,4.8-1.8,7.4c-2.5-0.6-5.3,0.2-7.2,2.2c-1.9,2-2.5,4.8-1.8,7.4l-1.4-1.4
					c-0.7-0.6-1.9-0.7-2.6,0.1c-0.6,0.7-0.7,2,0.1,2.6l5.7,5.4c0.9,0.8,0.6,2.2-0.1,3s-2.2,1-3,0.2L398,324l-5.7-5.3
					c-0.7-0.6-1.9-0.7-2.6,0.1c-0.7,0.7-0.7,2,0.1,2.6l5.7,5.3l0.1,0.1c0.9,0.9,0.6,2.2,0.1,2.9c-0.6,0.7-1.6,0.9-2.8,0.4l-7.4-3.4
					c-1.8-0.8-3.2,0.1-3.8,0.6l-1.4,1.4c-0.6,0.7-0.7,1.9,0,2.5c0.7,0.7,1.9,0.6,2.6-0.1l0.8-0.9c0.2-0.2,0.4-0.2,0.6-0.1l6.9,3.2
					c2.3,1,4.9,0.9,7-1.3c1-1.1,1.6-2.5,1.6-4c1.7-0.1,3.1-0.9,4-1.9c2.1-2.2,2.5-4.8,1-7c2.6,0.7,5.5,0,7.5-2.1
					c1.9-2,2.5-4.9,1.8-7.4c1.8,0.4,3.7,0.2,5.2-0.7 M431.3,291.4l-4.2-3.9l-0.1-0.1c-0.9-0.9-0.6-2.2-0.1-2.9
					c0.5-0.7,1.6-0.9,2.8-0.4l4.9,2.3 M426.4,298.2l-5-4.8c-0.9-0.8-0.6-2.2,0.1-3s2.2-1,3-0.2l0.1,0.1l4.5,4.2 M423.5,302.3
					c0-0.6-0.1-1.4-0.3-2l1.4,1.4 M409.6,314.7c-1.5,1.6-4.1,1.7-5.7,0.1c-1.7-1.6-1.7-4.2-0.2-5.7c1.5-1.6,4.2-1.7,5.7-0.2
					C411.1,310.4,411.2,313,409.6,314.7z M418.7,305.1c-1.5,1.6-4.1,1.7-5.7,0.1c-1.6-1.5-1.7-4.2-0.2-5.7s4.2-1.7,5.7-0.2
					C420.1,300.8,420.2,303.5,418.7,305.1z" />
            </g>
        </g>
        <g class="saddle-normal">
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M290.1,182.2c-6.6,2.4-18,10.8-28.7,10.6c-2.2,0-4.6-0.2-7.2-0.4c-9.7-1-20.9-4.2-27.4-11
				c-8-8.6,1.6-12.5,3.2-12.8c1.7-0.2,21.4-0.3,26.6-0.4c5.1-0.1,57.1-3.4,61.8-3.9c4.7-0.5,8.5,2.6,9.3,5.4s0.6,4-3.8,4.1
				s-16.9,2.8-23.8,5C293.4,181.1,292.8,181.2,290.1,182.2z" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M254.3,192.4c2,2.4,3,6,10.5,4s20.5-4.8,23.1-6.5s4.5-3.7,9.3-9.9" />
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="269.7"
                y1="196"
                x2="291.6"
                y2="247.3" />
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="282.6"
                y1="192.8"
                x2="303.4"
                y2="242.7" />
        </g>
        <g class="x-handlebar-normal">
            <polyline
                class="fill-none stroke-woom-black stroke-2"
                points="496.2,147.5 495.9,146.4 496.5,140.6 494.6,139.7 493.8,137.3 495.5,136.1 493.4,130.9 490.7,130.5
				489.5,128.3 490,126.5 506.7,119" />
            <polyline
                class="fill-none stroke-woom-black stroke-2"
                points="515.4,138.7 511.6,135.5 512.5,133.8 511.1,130.1 519.7,122.2" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M510.1,119.8l7.9,2.6c0,0,6.3,0.1,6.9-6.6c0.9-5-3.4-7.3-3.4-7.3l-8.7-2.8" />

            <ellipse
                transform="matrix(0.5848 -0.8112 0.8112 0.5848 120.4401 460.5475)"
                class="fill-none stroke-woom-black stroke-2"
                cx="510.1"
                cy="112.6"
                rx="7.2"
                ry="7.2" />
        </g>
        <g class="tyres hidden">
            <g class="inline">
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="164.4"
                            y1="243.8"
                            x2="164.4"
                            y2="532.1" />
                        <g>
                            <rect
                                x="156.6"
                                y="242.7"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.3" />
                        </g>
                        <g>
                            <rect
                                x="156.6"
                                y="531"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.3" />
                        </g>
                    </g>
                </g>
            </g>
            <g class="inline">
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="635.5"
                            y1="243.8"
                            x2="635.5"
                            y2="532.1" />
                        <g>
                            <rect
                                x="627.7"
                                y="242.7"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.3" />
                        </g>
                        <g>
                            <rect
                                x="627.7"
                                y="531"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.3" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <g class="cockpit hidden">
            <g class="inline">
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="509.6"
                            y1="113.8"
                            x2="509.6"
                            y2="532.1" />
                        <g>
                            <rect
                                x="501.8"
                                y="112.6"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.4" />
                        </g>
                        <g>
                            <rect
                                x="501.8"
                                y="530.9"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.4" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <g class="steering-angle hidden">
            <g class="inline">
                <g>
                    <polyline
                        class="h-line-miter fill-none stroke-woom-red stroke-3"
                        points="475.5,75.5 534.5,201.6 409.4,201.6" />
                </g>
                <path
                    class="h-line-miter fill-none stroke-woom-red stroke-3"
                    d="M485.6,201.3c0-19.5,11.6-36.4,28.2-44" />
            </g>
            <g class="inline">
                <g>
                    <g>
                        <g>
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="537.6"
                                y1="207.9"
                                x2="539.3"
                                y2="211.7" />
                            <line
                                class="h-dash-line fill-none stroke-woom-red stroke-3"
                                x1="542.7"
                                y1="219.5"
                                x2="678.1"
                                y2="525.7" />
                            <polyline
                                class="h-line fill-none stroke-woom-red stroke-3"
                                points="679.8,529.5 681.5,533.3 677.9,533.3" />
                            <line
                                class="h-dash-line fill-none stroke-woom-red stroke-3"
                                x1="670.3"
                                y1="533.3"
                                x2="568"
                                y2="533.3" />
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="564.2"
                                y1="533.3"
                                x2="560.5"
                                y2="533.3" />
                        </g>
                    </g>
                </g>
                <g>
                    <g>
                        <path
                            class="h-line fill-none stroke-woom-red stroke-3"
                            d="M626.8,530c0-1.4,0.1-2.8,0.2-4.2" />
                        <path
                            class="h-dash-line fill-none stroke-woom-red stroke-3"
                            d="M628.7,515.9c3.2-11.3,10.3-21.1,19.8-27.8" />
                        <path
                            class="h-line fill-none stroke-woom-red stroke-3"
                            d="M652.8,485.7c1.2-0.7,2.4-1.4,3.7-1.9" />
                    </g>
                </g>
            </g>
        </g>
        <g class="top-tube-horizontal hidden">
            <g class="inline">
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="503.6"
                            y1="132.3"
                            x2="276.8"
                            y2="132.3" />
                        <g>
                            <rect
                                x="502.4"
                                y="128.4"
                                class="fill-woom-red stroke-woom-red"
                                width="2.3"
                                height="7.8" />
                        </g>
                        <g>
                            <rect
                                x="275.7"
                                y="128.4"
                                class="fill-woom-red stroke-woom-red"
                                width="2.3"
                                height="7.8" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <g class="wheelbase hidden">
            <g class="inline">
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="635"
                            y1="386.7"
                            x2="165.9"
                            y2="386.7" />
                        <g>
                            <rect
                                x="633.9"
                                y="382.6"
                                class="fill-woom-red stroke-woom-red"
                                width="2.4"
                                height="8.2" />
                        </g>
                        <g>
                            <rect
                                x="164.8"
                                y="382.6"
                                class="fill-woom-red stroke-woom-red"
                                width="2.4"
                                height="8.2" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <g class="seat-tube-angle hidden">
            <g class="inline">
                <polyline
                    class="h-line-miter fill-none stroke-woom-red stroke-3"
                    points="301.5,252.7 407.2,532.2 164,533.3" />
            </g>
            <path
                class="h-line-miter inline fill-none stroke-woom-red stroke-3"
                d="M353.3,532.2c0-23.9,13.1-42.6,33.4-51.9" />
        </g>
        <g class="min-saddle-height hidden">
            <g class="inline">
                <g>
                    <g>
                        <g>
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="288.7"
                                y1="197.1"
                                x2="284.3"
                                y2="197.1" />
                            <line
                                class="h-dash-line fill-none stroke-woom-red stroke-3"
                                x1="275.5"
                                y1="197.1"
                                x2="31.9"
                                y2="197.1" />
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="27.6"
                                y1="197.1"
                                x2="23.1"
                                y2="197.1" />
                        </g>
                    </g>
                </g>
                <g>
                    <g>
                        <g>
                            <g>
                                <line
                                    class="h-line fill-none stroke-woom-red stroke-3"
                                    x1="10"
                                    y1="197.1"
                                    x2="10"
                                    y2="532.1" />
                                <g>
                                    <rect
                                        x="2.2"
                                        y="195.9"
                                        class="fill-woom-red stroke-woom-red"
                                        width="15.6"
                                        height="2.3" />
                                </g>
                                <g>
                                    <rect
                                        x="2.2"
                                        y="531"
                                        class="fill-woom-red stroke-woom-red"
                                        width="15.6"
                                        height="2.3" />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
            <g class="inline">
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M303.1,212.2c-6.6,2.4-18,10.8-28.7,10.6c-2.2,0-4.6-0.2-7.2-0.4c-9.7-1-20.9-4.2-27.4-11
					c-8-8.6,1.6-12.5,3.2-12.8c1.7-0.2,21.4-0.3,26.6-0.4c5.1-0.1,57.1-3.4,61.8-3.9c4.7-0.5,8.5,2.6,9.3,5.4s0.6,4-3.8,4.1
					s-16.9,2.8-23.8,5C306.4,211.1,305.8,211.2,303.1,212.2z" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M267.3,222.4c2,2.4,3,6,10.5,4s20.5-4.8,23.1-6.5s4.5-3.7,9.3-9.9" />
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="282.7"
                    y1="226"
                    x2="291.6"
                    y2="247.3" />
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="295.6"
                    y1="222.8"
                    x2="303.4"
                    y2="242.7" />
            </g>
        </g>
        <g class="max-saddle-height hidden">
            <g class="inline">
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="10"
                            y1="137.5"
                            x2="10"
                            y2="532.1" />
                        <g>
                            <rect
                                x="2.2"
                                y="136.3"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.4" />
                        </g>
                        <g>
                            <rect
                                x="2.2"
                                y="530.8"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.4" />
                        </g>
                    </g>
                </g>
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="263.7"
                            y1="137.5"
                            x2="259.6"
                            y2="137.5" />
                        <line
                            class="h-dash-line fill-none stroke-woom-red stroke-3"
                            x1="251"
                            y1="137.5"
                            x2="31.6"
                            y2="137.5" />
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="27.3"
                            y1="137.5"
                            x2="23.1"
                            y2="137.5" />
                    </g>
                </g>
            </g>
            <g class="inline">
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M278.1,154.2c-6.6,2.4-18,10.8-28.7,10.6c-2.2,0-4.6-0.2-7.2-0.4c-9.7-1-20.9-4.2-27.4-11
					c-8-8.6,1.6-12.5,3.2-12.8c1.7-0.2,21.4-0.3,26.6-0.4s57.1-3.4,61.8-3.9s8.5,2.6,9.3,5.4s0.6,4-3.8,4.1s-16.9,2.8-23.8,5
					C281.4,153.1,280.8,153.2,278.1,154.2z" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M242.3,164.4c2,2.4,3,6,10.5,4c7.4-2,20.5-4.8,23.1-6.5s4.5-3.7,9.3-9.9" />
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="257.7"
                    y1="168"
                    x2="291.6"
                    y2="247.3" />
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="270.6"
                    y1="164.8"
                    x2="303.4"
                    y2="242.7" />
            </g>
        </g>
        <g class="crank-length hidden">
            <g class="inline">
                <line
                    class="h-line-miter fill-none stroke-woom-red stroke-3"
                    x1="358.4"
                    y1="407.4"
                    x2="402.1"
                    y2="450.3" />
                <g>
                    <rect
                        x="351.5"
                        y="406.3"
                        transform="matrix(0.7006 -0.7136 0.7136 0.7006 -183.3025 377.7996)"
                        class="fill-woom-red stroke-woom-red"
                        width="14"
                        height="2.1" />
                </g>
                <g>
                    <rect
                        x="395.1"
                        y="449.2"
                        transform="matrix(0.7006 -0.7136 0.7136 0.7006 -200.8745 421.7414)"
                        class="fill-woom-red stroke-woom-red"
                        width="14"
                        height="2.1" />
                </g>
            </g>
        </g>
        <g class="handlebar-adjustability hidden">
            <g class="inline">
                <polyline
                    class="h-line-miter fill-none stroke-woom-red stroke-3"
                    points="563.7,123.3 499.5,132.6 543,85.2" />
            </g>
            <path
                class="h-line-miter inline fill-none stroke-woom-red stroke-3"
                d="M517.9,112.6c8.7,2.7,10.9,7,8.8,15.5" />
        </g>
        <g class="stand-over-height hidden">
            <g class="inline">
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="17.8"
                            y1="232.8"
                            x2="17.8"
                            y2="532.1" />
                        <g>
                            <rect
                                x="10"
                                y="231.6"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.4" />
                        </g>
                        <g>
                            <rect
                                x="10"
                                y="530.9"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.4" />
                        </g>
                    </g>
                </g>
            </g>
            <g class="inline">
                <g>
                    <g>
                        <g>
                            <line
                                class="h-dash-line fill-none stroke-woom-red stroke-3"
                                x1="378.2"
                                y1="232.7"
                                x2="39.6"
                                y2="232.7" />
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="35"
                                y1="232.7"
                                x2="30.7"
                                y2="232.7" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>
